import {
  FlexBox,
  JoonUIColor,
  ParentTraining,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import dayjs from "dayjs"
import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"

import NotificationDot from "../../../components/notificationDot/NotificationDot"
import { ParentTrainingStatusColors } from "../../../constants"
import { useInReviewTodosQuery } from "../../../networking/queries"
import { ParentTrainingTab, PatientInfoTab } from "../../../types"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"
import { StatusBar } from "../behaviorsIncidents/AddTargetBehaviorModal"

const ParentTrainingItem = ({
  parentTraining,
  numNewIncidents,
}: {
  parentTraining: ParentTraining
  numNewIncidents: number
}) => {
  const navigate = useNavigate()
  const { userId, trainingId } = useParams()
  const [isHovered, setIsHovered] = useState(false)
  const isSelected = Number(trainingId) === parentTraining.id
  const { data: inReviewTodos } = useInReviewTodosQuery()

  const hasInReviewTodos = inReviewTodos?.some(
    (todo) => todo.series.parent_training_id === parentTraining.id
  )

  const hasUnreviewedModules = parentTraining.assignments.some(
    (assignment) =>
      !!assignment.assignment_completion.date_completed &&
      !assignment.assignment_completion.date_reviewed
  )

  const navigateToTraining = () => {
    navigate(
      `/patients/${userId}/${PatientInfoTab.PARENT_TRAINING}/${parentTraining.id}/${ParentTrainingTab.SUMMARY}`
    )
    trackAnalyticEvent(ANALYTIC_EVENTS.view_parent_training)
  }

  return (
    <button
      onClick={navigateToTraining}
      style={{
        padding: 0,
        width: "100%",
        borderRadius: SPACING.space2,
        background: isSelected
          ? JoonUIColor.background.lightBlue
          : JoonUIColor.background.primaryNeutral,
        outline:
          isSelected || isHovered
            ? `2px solid ${JoonUIColor.semantic.primary}`
            : undefined,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <FlexBox
        direction="row"
        justify="space-between"
        align="center"
        wrap={false}
        style={{
          padding: SPACING.space4,
          border: `1px solid ${JoonUIColor.border.default}`,
          borderRadius: SPACING.space2,
        }}
      >
        <FlexBox
          direction="row"
          align="center"
          wrap={false}
          gap={SPACING.space2}
        >
          <StatusBar
            color={ParentTrainingStatusColors[parentTraining.status].bar}
            height={SPACING.space10}
          />
          <FlexBox direction="column">
            <Typography variant="caption" textAlign="left">
              {parentTraining.title}
            </Typography>
            <Typography variant="bodyXSmall" textAlign="left">
              Started on: {dayjs(parentTraining.date_created).format("MMM D")}
            </Typography>
          </FlexBox>
        </FlexBox>
        {(numNewIncidents > 0 || hasInReviewTodos || hasUnreviewedModules) && (
          <FlexBox
            wrap={false}
            align="center"
            gap={SPACING.space1}
            style={{ width: "fit-content" }}
          >
            <NotificationDot />
            <Typography
              variant="caption"
              style={{ fontWeight: "600", whiteSpace: "nowrap" }}
              color={JoonUIColor.semantic.destructive}
            >
              New activity
            </Typography>
          </FlexBox>
        )}
      </FlexBox>
    </button>
  )
}

export default ParentTrainingItem
